import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const Container = styled.div`
box-sizing: border-box;
width: 100%;
border: 1px solid #c5c5c5;
border-radius: 7px;
display: -webkit-box;
display: -webkit-flex;
display: -ms-flexbox;
display: flex;
margin-left: 0;
background-color: white;
padding: 22px 40px;
margin-bottom:15px;
@media (max-width:990px) {
  overflow-x:scroll;
  overflow-y:hidden;
  margin-top:10px;
}
`
export const CustomLink = styled(NavLink)`
&.TabActive{
  color:#006BFF;
  position:relative;
  &:after{
    position: absolute;
    content: "";
    width: 100%;
    border-bottom: 4px solid #006BFF;
    left: 0;
    right: 0;
    bottom: -23px;
    margin: 0 auto;
  }
}
height: 100%;
min-width:150px;
font-size:17px;
text-align: center;
font-weight: 600;
color:#CCCCCC;
border-bottom: ${props => props.border ? props.border : ""};
cursor: pointer;
margin-right:20px;
text-decoration:none;
font-weight:600;
font-family: Montserrat SemiBold, "Open Sans", Helvetica, Arial, sans-serif;
{/*&:hover{
  color:#4678ED;
  border-bottom: 4px solid #2196F3;
}*/}
@media (max-width: 1124px) {
  min-width:125px;
} 
@media (max-width: 906px) {
  font-size:12.5px;
  min-width:90px;
}
@media (max-width: 656px) {
  font-size:11px;
  min-width:75px;
}
@media (max-width: 556px) {
  font-size:9.5px;
  min-width:65px;
}
`